/**
 * Language codes for languages supported in Bloomberg terminal via TRAN
 */
export const BBUILocales = ['en', 'es', 'ja', 'fr', 'de', 'pt', 'it', 'zt', 'ko', 'zh', 'ru'] as const;
export type BBUILocale = (typeof BBUILocales)[number];
export type I18nInfo<T extends string> = {
    /**
     * Override the locale used to render labels for this component
     * @since 3.1.0
     */
    locale?: string;
    /**
     * Override individual labels for this component. See Localization section of the component's documentation page for details.
     * @since 3.1.0
     */
    messages?: Partial<Record<T, string>>;
};
export type LocalizedProps<K extends string, Props> = Props & I18nInfo<K>;
